export const colors = {
  // Core
  background: "#000",
  black: "#000",
  cardBg: "#2a2a2a",

  dark: "#191919",

  darkBackground: "#000",
  darkGray: "#333",
  darkIcon: "#9BA1A6",
  darkOverlay: "rgba(0,0,0,0.7)",
  // Theme - dark
  darkText: "#ECEDEE",
  divider: "#222",
  grey: "#2c2c2c",
  // Grays
  light: "#aaaaaa",
  lightBackground: "#fff",
  lightIcon: "#687076",

  // Theme - light
  lightText: "#11181C",
  maroon: "#340a0a",
  midGray: "#444",

  modal: "#1a1a1a",
  muted: "#999",
  overlay: "rgba(0, 0, 0, 0.5)",

  placeholder: "#888",
  // Semantic
  red: "#901313",
  sheet: "#111",
  subtle: "#666",
  themeColor: "#111212",
  tint: "#0a7ea4",
  transparent: "transparent",
  white: "#fff",
};
